import MapItem from './MapItem';

export default MapItem;
